import { render, staticRenderFns } from "./RecordRelation.vue?vue&type=template&id=438eca56&scoped=true&"
import script from "./RecordRelation.vue?vue&type=script&lang=js&"
export * from "./RecordRelation.vue?vue&type=script&lang=js&"
import style0 from "./RecordRelation.vue?vue&type=style&index=0&id=438eca56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438eca56",
  null
  
)

export default component.exports